/**
 * Production-safe logger.
 * - In development: forwards to console.
 * - In production: debug/info become no-ops; warn/error still surface so real issues aren't silenced.
 */
const isProd = process.env.NODE_ENV === 'production';

export const logger = {
  debug: isProd ? () => {} : (...a) => console.debug(...a),
  info:  isProd ? () => {} : (...a) => console.info(...a),
  log:   isProd ? () => {} : (...a) => console.log(...a),
  warn:  (...a) => console.warn(...a),
  error: (...a) => console.error(...a),
};

export default logger;
